import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import LaunchIcon from '@mui/icons-material/Launch'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import Typography from '@mui/material/Typography'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import Box from '@mui/material/Box'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import Chip from '@mui/material/Chip'

import { BookModalStyle } from '../styles'
import { BootstrapDialog, BootstrapDialogTitle } from '../shared/BootstrapDialog'
import ResourceDescription from '../shared/ResourceDescription'

import useFavourite from '../../hooks/useFavourite'
import { copyResourceLink } from './copyResourceLink'
import { openExternal } from '../../utils/safeUrl'

const BookModal = (props) => {
    const user = useSelector(state => state.user)
    const dispatch = useDispatch()

    const [open, setOpen] = useState(props.initialOpen || false)
    const { favourited, toggleFavourite } = useFavourite(props, 'book')

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        if (props.onExternalClose) props.onExternalClose()
    }

    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const handleCopyLink = async () => {
        await copyResourceLink({ dispatch, resourcePath: 'books', resourceId: props.id })
    }

    return (
        <div>

            {!props.initialOpen && <Button {...BookModalStyle.viewButton.props} sx={BookModalStyle.viewButton.style} onClick={()=>handleClickOpen()}>
                More Info
            </Button>}
            <BootstrapDialog
                onClose={()=>handleClose()}
                aria-labelledby={`book-modal-${props.id}`}
                open={open}
                fullWidth
                {...BookModalStyle.modal}
            >
                <BootstrapDialogTitle id={`book-modal-${props.id}`} onClose={()=>handleClose()}>
                    <Box sx={BookModalStyle.headingContainer}>
                        <MenuBookIcon sx={BookModalStyle.icon}/>
                        {props.title}
                    </Box>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Box sx={BookModalStyle.content}>
                        <Box sx={BookModalStyle.dateContainer}>
                            <Box sx={BookModalStyle.dates}>
                                <Typography {...BookModalStyle.heading}>
                                    Posted:&nbsp;
                                </Typography>
                                <Typography {...BookModalStyle.text}>
                                    {props.updated.split('T')[0]}
                                </Typography>
                            </Box>
                            <Box sx={BookModalStyle.dates}>
                                <Typography {...BookModalStyle.heading}>
                                    Published:&nbsp;
                                </Typography>
                                <Typography {...BookModalStyle.text}>
                                    {props.pub_date}
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Box sx={BookModalStyle.ratingContainer}>
                                {user && !user.anon && <IconButton onClick={toggleFavourite}>
                                    {favourited? <BookmarkIcon sx={BookModalStyle.favColour} /> : <BookmarkBorderIcon sx={BookModalStyle.favColour} />}
                                </IconButton>}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={BookModalStyle.mobileContainer}>
                        <Box sx={BookModalStyle.mobileRating}>
                            {user && !user.anon && <IconButton onClick={toggleFavourite}>
                                {favourited? <BookmarkIcon sx={BookModalStyle.favColour} /> : <BookmarkBorderIcon sx={BookModalStyle.favColour} />}
                            </IconButton>}
                        </Box>
                        <Box sx={BookModalStyle.mobileDate}>
                            <Typography gutterBottom {...BookModalStyle.dateHeading}>
                                Posted:&nbsp;
                            </Typography>
                            <Typography gutterBottom {...BookModalStyle.text}>
                                {props.updated.split('T')[0]}
                            </Typography>
                        </Box>
                        <Box sx={BookModalStyle.mobileDate}>
                            <Typography gutterBottom {...BookModalStyle.dateHeading}>
                                Published:&nbsp;
                            </Typography>
                            <Typography gutterBottom {...BookModalStyle.text}>
                                {props.pub_date}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={BookModalStyle.additionalInfo}>
                        <Typography {...BookModalStyle.text} gutterBottom>
                            <strong>Book Type:</strong> {props.book_type_name}
                        </Typography>
                    </Box>
                    <Box sx={BookModalStyle.additionalInfo}>
                        <Typography {...BookModalStyle.text} gutterBottom>
                            <strong>ISBN:</strong> {props.isbn}
                        </Typography>
                    </Box>
                    <Box sx={BookModalStyle.additionalInfo}>
                        <Typography {...BookModalStyle.text} gutterBottom>
                            <strong>Authors:</strong> {props.authors}
                        </Typography>
                    </Box>
                    <ResourceDescription
                        description={props.description}
                        containerSx={BookModalStyle.additionalInfo}
                        typographyProps={{ ...BookModalStyle.text, gutterBottom: true }}
                    />
                    {props.content_tags && props.content_tags.map(tag => <Chip sx={BookModalStyle.chips} key={tag} label={tag} />)}
                    {props.medical_specialty_tags && props.medical_specialty_tags.map(tag => <Chip sx={BookModalStyle.chips} key={tag} label={tag} />)}
                    </DialogContent>
                <DialogActions>
                    <Button onClick={handleCopyLink}>
                        Copy Link&nbsp;<ContentCopyIcon />
                    </Button>
                    <Button onClick={()=>openResource()}>
                        View Resource&nbsp;<LaunchIcon />
                    </Button>
                    <Button autoFocus onClick={()=>handleClose()}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default BookModal
